<template>
  <div class="account-information-destination-field">
    <div class="account-information-destination-field-label">
      <span
        class="destination-name"
        v-text="interest.label"
      />
      <!-- <span class="country-name" v-text="interest.country"></span> -->
    </div>
    <div class="account-information-destination-field-action">
      <button
        v-if="!isLoading"
        href="#"
        class="account-information-field-cta__remove"
        :aria-label="`${remove} ${label}: ${interest.label}`"
        :disabled="isUpdateProfilePending"
        @click.prevent="removeItem"
        @keydown.space.prevent="removeItem"
      >
        {{ remove }}
      </button>
      <span
        v-else
        class="icon-loading-black"
      />
    </div>
  </div>
</template>
<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'DestinationValueItem',
    props: {
      interest: {
        type: Object,
        required: true
      },
      label: {
        type: String,
        default: 'my destination'
      },
      remove: {
        type: String,
        default: 'remove'
      }
    },
    data: () => ({
      isLoading: false
    }),
    computed: {
      ...mapState('auth', ['isUpdateProfilePending']),
    },
    methods: {
      ...mapActions('auth', ['updateProfile']),
      async removeItem() {
        this.isLoading = true
        await this.updateProfile({ data: { preferenceCodes: [this.interest.value] }, method: 'delete', endpoint: 'preferences' })
        this.isLoading = false
      }
    }
  }
</script>
